export class SystemDateTimeProvider {
    private isSyncronised = false;
    private systemNowAtSync: number;
    private elapsedTimeStart: number;

    public sync(systemNow: Date) {
        this.systemNowAtSync = systemNow.getTime();
        this.elapsedTimeStart = performance.now();
        this.isSyncronised = true;
    }

    public now(): Date {
        if (this.isSyncronised) {
            const elapsed = performance.now() - this.elapsedTimeStart;
            return new Date(this.systemNowAtSync + elapsed);
        }

        return new Date();
    }
}

const dateTimeProvider = new SystemDateTimeProvider();

export default dateTimeProvider;
